var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"page-title page-inner"},[_vm._v(" "+_vm._s(_vm.$route.meta.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }